import React, { useState, useRef, useEffect } from 'react';
import styled from "styled-components";
import Avvvatars from "avvvatars-react";
import dayjs from "dayjs";
import useAPI from "../../hooks/useAPI";
import { Tooltip } from 'react-tooltip'
// ICONOS
import { FaSpinner, FaBell, FaBellSlash, FaFilter, FaImage, FaUser, FaDatabase, FaBan } from "react-icons/fa";
import { BsSearch, BsFillCameraVideoFill, BsFillFileEarmarkTextFill, BsCheckAll, BsCheck, BsPersonFillSlash } from "react-icons/bs";
import { LiaEditSolid } from "react-icons/lia";
import { IoFilterCircleOutline, IoLocationOutline, IoClose } from "react-icons/io5";
import { PiUserSwitchFill, PiStickerLight } from "react-icons/pi";
import { HiMicrophone } from "react-icons/hi2";
import { HiShoppingCart, HiTemplate} from "react-icons/hi";
import { LuWorkflow } from "react-icons/lu";
import { TbCubeSend, TbMessage2X, TbMessagePlus } from "react-icons/tb";
import { TiArrowBack } from "react-icons/ti";
import { IoIosAlarm } from 'react-icons/io';
import { getWhatsappDisplayName, getWhatsappIdentifier, isSameWhatsappIdentity } from '../../utils/whatsappIdentity';

const ListConversations = ({
  setNewChat,
  setSearchConversation,
  setActiveNotification,
  setClassChat,
  activeNotification,
  numberPageConversations,
  totalPagesConversations,
  filterRef,
  filter,
  filterState,
  listTagsAll,
  validationChats,
  listUserChats,
  listUserChatsRef,
  loadingChats,
  textConversations,
  onChatSelected,
  getTagContact,
  getConversationsAsign,
  getConversations,
  getConversationsPending, 
  getConversationsNoAsign,
  getConversationsBots,
  conversationsListRef,
  fetchConversations,
  previousScrollHeightRef,
  previousScrollTopRef,
  conversationsPendingCount,
  conversationsAssignedCount,
  conversationsUnassignedCount,
  conversationsBotCount,
  filterByStatusAndTagsRef,
  activeCache,
  setActiveCache,
  showTooltip
}) => {

  // const [loading, setLoading] = useState(false);
  const [loadingMoreConversations, setLoadingMoreConversations] = useState(false);
  const loadingMoreConversationsRef = useRef(false);
  const [notMessages, setNotMessages] = useState("");
  const [selectedChat, setSelectedChat] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [loadingListContacts, setLoadingListContacts] = useState(false);
  const [loadingListConv, setLoadingListConv] = useState(false);
  const [filterTags, setFilterTags] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");
  const [tagSearchTerm, setTagSearchTerm] = useState("");
  const [showAllTags, setShowAllTags] = useState(false);
  const previousInboxFilterRef = useRef(filter);
  const [recentTagIds, setRecentTagIds] = useState(() => {
    try {
      const storedIds = JSON.parse(localStorage.getItem("RECENT_CONVERSATION_FILTER_TAGS") || "[]");
      return Array.isArray(storedIds) ? storedIds : [];
    } catch (error) {
      return [];
    }
  });

  const { urlAPI_1 } = useAPI();
  const roleId = localStorage.getItem("USER_ROLEID");

  useEffect(() => {
    if (filter === "pending") {
      setFilterTags("3");
      setShowFilter(false);
    } else if (previousInboxFilterRef.current === "pending") {
      setFilterTags("all");
      filterByStatusAndTagsRef.current = "";
    }
    previousInboxFilterRef.current = filter;
  }, [filter, filterByStatusAndTagsRef]);

  const getRelativeDate = (timestamp) => {
    let daysOfWeek = ["dom", "lun", "mar", "mie", "jue", "vie", "sab"];
    let today = new Date();
    today.setHours(0, 0, 0, 0); // Establezco la hora a las 00:00 hs
    today = today.getTime();
    let oneDay = 24 * 60 * 60 * 1000; // Milisegundos en un día
    let fiveDays = oneDay * 5;

    if(today - timestamp > fiveDays){
      let date_return = new Date(timestamp);
      return dayjs(date_return).locale("es").format("DD-MMM hh:mm a");
    }

    let yesterday = today - oneDay;
    today = new Date(today);
    yesterday = new Date(yesterday);

    daysOfWeek[today.getDay()] = "";
    daysOfWeek[yesterday.getDay()] = "ayer";

    const date = new Date(timestamp);
    const day = date.getDay(); // Obtengo el número del día de la semana (0-6)
    let date_return = new Date(timestamp);
    return daysOfWeek[day] + " " + dayjs(date_return).locale("es").format("hh:mm a");
  }
  
  const onScrollDownConversations = async () => {
    if (loadingMoreConversationsRef.current) return;
    if(!conversationsListRef.current) return;

    if ((conversationsListRef.current.scrollTop + conversationsListRef.current.clientHeight >= conversationsListRef.current.scrollHeight - 10) && (numberPageConversations <= totalPagesConversations)) {
      console.log("onScrollDownConversations!!!");
      if(listUserChatsRef.current.length < 10){
        return;
      }
      // Lógica para cargar mas conversaciones
      loadingMoreConversationsRef.current = true;
      setLoadingMoreConversations(true);
      let url = "";
      switch (filterRef.current) {
        case 'all':
          url = urlAPI_1 + "fetchMessages?page=" + `${numberPageConversations}` + "&origin=frontend-v2";
          break;
        case 'onHold':
          url = urlAPI_1 + "fetchMessages?page=" + `${numberPageConversations}` + "&list=noAsign" + "&origin=frontend-v2";
          break;
        case 'mine':
          url = urlAPI_1 + "fetchMessages?page=" + `${numberPageConversations}` + "&list=asign" + "&origin=frontend-v2";
          break;
        case 'bots':
            url = urlAPI_1 + "fetchMessages?page=" + `${numberPageConversations}` + "&list=bot" + "&origin=frontend-v2";
            break;
        case 'pending':
          url = urlAPI_1 + "fetchMessages?page=" + `${numberPageConversations}` + "&list=pending"  + "&origin=frontend-v2";
          break        
        default:
          url = urlAPI_1 + "fetchMessages?page=" + `${numberPageConversations}` + "&origin=frontend-v2";
          break;
      }
      console.log("(onScrollDownConversations) filterByStatusAndTagsRef.current: ", filterByStatusAndTagsRef.current);
      if (filterByStatusAndTagsRef.current) {
        url += `&filter=${filterByStatusAndTagsRef.current}`;
      };
      previousScrollTopRef.current = conversationsListRef.current.scrollTop;
      previousScrollHeightRef.current = conversationsListRef.current.scrollHeight;
      await fetchConversations(url);
      loadingMoreConversationsRef.current = false;
      setLoadingMoreConversations(false);
    }
  };

  useEffect(() => {
    const loadMoreUntilListCanScroll = () => {
      const conversationsList = conversationsListRef.current;
      if (!conversationsList || loadingMoreConversationsRef.current) return;

      const hasMorePages = numberPageConversations <= totalPagesConversations;
      const listDoesNotOverflow = conversationsList.scrollHeight <= conversationsList.clientHeight + 10;

      if (hasMorePages && listDoesNotOverflow && listUserChatsRef.current.length >= 10) {
        onScrollDownConversations();
      }
    };

    const animationFrameId = window.requestAnimationFrame(loadMoreUntilListCanScroll);
    window.addEventListener("resize", loadMoreUntilListCanScroll);

    return () => {
      window.cancelAnimationFrame(animationFrameId);
      window.removeEventListener("resize", loadMoreUntilListCanScroll);
    };
  }, [listUserChats.length, numberPageConversations, totalPagesConversations]);

  const onFilterTags = (e) => {
    console.log('Filtrando por etiquetas...')
    console.log('VAlor de etiqueta seleccionada...:', e)
    if(!e) return;
    filterByStatusAndTagsRef.current = e;
    switch (filterRef.current) {
      case "all":
          getConversations(e);
          break;
      case "mine":
          getConversationsAsign(e);
          break;
      case "onHold":
          getConversationsNoAsign(e);
          break;
      case "pending":
          getConversationsPending(e);
          break;
      case "bots":
          getConversationsBots(e);
          break;
      default:
          getConversationsAsign(e);
          break;
    }
    setShowFilter(false);
  };

  const onFilterUnread = () => {
    filterByStatusAndTagsRef.current = "unread";
    switch (filterRef.current) {
      case "all":
        getConversations("unread");
        break;
      case "mine":
        getConversationsAsign("unread");
        break;
      case "onHold":
        getConversationsNoAsign("unread");
        break;
      case "pending":
        getConversationsPending("unread");
        break;
      case "bots":
        getConversationsBots("unread");
        break;
      default:
        getConversationsAsign("unread");
        break;
    }
    setShowFilter(false);
  };

  const onFilterStatus = (e) => {
    if(!e) return;
    const statusId = String(e);
    if(["1", "2", "3"].includes(statusId)){
      const statusFilter = "status_" + statusId;
      filterByStatusAndTagsRef.current = statusFilter;
      switch (filterRef.current) {
        case "all":
          getConversations(statusFilter);
          break;
        case "mine":
          getConversationsAsign(statusFilter);
          break;
        case "onHold":
          getConversationsNoAsign(statusFilter);
          break;
        case "pending":
          getConversationsPending(statusFilter);
          break;
        case "bots":
          getConversationsBots(statusFilter);
          break;
        default:
          getConversationsAsign(statusFilter);
          break;
      }
    } else {
      filterByStatusAndTagsRef.current = "";
      getConversations();
    }
    setShowFilter(false);
  };

  const getFilterLabel = () => {
    if (filterTags === "all") return "";
    if (filterTags === "unread") return "No leídos";
    const statusMap = { "1": "Abierto", "2": "Cerrado", "3": "En espera" };
    if (statusMap[filterTags]) return statusMap[filterTags];
    const tag = listTagsAll.find(t => t._id === filterTags);
    return tag ? tag.title : "";
  };

  const clearFilter = () => {
    onFilterTags("all");
    setFilterTags("all");
  };

  const selectTagFilter = (tagId) => {
    const normalizedTagId = String(tagId);
    const nextRecentTagIds = [normalizedTagId, ...recentTagIds.filter(id => String(id) !== normalizedTagId)].slice(0, 8);
    setRecentTagIds(nextRecentTagIds);
    localStorage.setItem("RECENT_CONVERSATION_FILTER_TAGS", JSON.stringify(nextRecentTagIds));
    setFilterTags(normalizedTagId);
    onFilterTags(normalizedTagId);
    setShowFilter(false);
  };

  const handleNewChatClick = () => {
    setLoadingListContacts(true);
    setTimeout(() => {
      setNewChat(true);
      setSelectedChat(null);
      setLoadingListContacts(false);
    }, 1500);
  };

  const filteredConversations = listUserChats.filter((chat) => {
    const query = searchTerm.trim().toLowerCase();
    if (!query) return true;
    const name = getWhatsappDisplayName(chat).toLowerCase();
    const identifier = String(getWhatsappIdentifier(chat) || "").toLowerCase();
    return name.includes(query) || identifier.includes(query);
  });
  const quickStatusFilters = Array.isArray(filterState)
    ? filterState.slice(0, 3)
    : [];
  const orderedTags = [...listTagsAll].sort((a, b) => {
    const aRecentIndex = recentTagIds.indexOf(String(a._id));
    const bRecentIndex = recentTagIds.indexOf(String(b._id));
    if (aRecentIndex !== -1 || bRecentIndex !== -1) {
      if (aRecentIndex === -1) return 1;
      if (bRecentIndex === -1) return -1;
      return aRecentIndex - bRecentIndex;
    }
    return String(a.title || "").localeCompare(String(b.title || ""), "es");
  });
  const matchingTags = orderedTags.filter(tag => String(tag.title || "").toLowerCase().includes(tagSearchTerm.trim().toLowerCase()));
  const visibleTags = showAllTags || tagSearchTerm ? matchingTags : matchingTags.slice(0, 8);

  return (
    <>
      <header className="su-conv-top">
        <label className="su-conv-search">
          <BsSearch aria-hidden="true" />
          <input
            value={searchTerm}
            onChange={(event) => setSearchTerm(event.target.value)}
            placeholder="Buscar nombre o teléfono"
            aria-label="Buscar nombre o teléfono"
          />
          {searchTerm && <button type="button" onClick={() => setSearchTerm("")} aria-label="Limpiar búsqueda"><IoClose /></button>}
        </label>
        <button type="button" className="su-conv-icon" onClick={() => {
          const notificationsState = localStorage.getItem("STATE_NOT");
          localStorage.setItem("STATE_NOT", notificationsState === "true" ? "false" : "true");
          setActiveNotification(!activeNotification);
        }} aria-label={activeNotification ? "Desactivar notificaciones" : "Activar notificaciones"}>
          {activeNotification ? <FaBell /> : <FaBellSlash />}
        </button>
        <button type="button" className="su-conv-icon" onClick={handleNewChatClick} aria-label="Nuevo chat"><TbMessagePlus /></button>
      </header>

      <nav className="su-conv-segments" aria-label="Bandejas de conversación">
        <button type="button" className={filter === "mine" ? "active" : ""} onClick={() => { filterByStatusAndTagsRef.current = ""; setFilterTags("all"); getConversationsAsign(); }}><FaUser /><i>{Number(conversationsAssignedCount) || 0}</i><span>Míos</span></button>
        <button type="button" className={filter === "pending" ? "active" : ""} onClick={() => { filterByStatusAndTagsRef.current = ""; setFilterTags("3"); setShowFilter(false); getConversationsPending(); }}><IoIosAlarm /><i>{Number(conversationsPendingCount) || 0}</i><span>Pendientes</span></button>
        <button type="button" className={filter === "onHold" ? "active" : ""} onClick={() => { filterByStatusAndTagsRef.current = ""; setFilterTags("all"); getConversationsNoAsign(); }}><BsPersonFillSlash /><i>{Number(conversationsUnassignedCount) || 0}</i><span>Sin asignar</span></button>
        <button type="button" className={filter === "bots" ? "active" : ""} onClick={() => { filterByStatusAndTagsRef.current = ""; setFilterTags("all"); getConversationsBots(); }}><TbCubeSend /><i>{Number(conversationsBotCount) || 0}</i><span>Bot</span></button>
        <button type="button" className={filter === "all" ? "active" : ""} onClick={() => { filterByStatusAndTagsRef.current = ""; setFilterTags("all"); getConversations(); }}><PiUserSwitchFill /><span>Todos</span></button>
      </nav>

      <div className="su-conv-chips" aria-label="Filtros rápidos">
        <button type="button" disabled={filter === "pending"} className={showFilter || !["all", "1", "2", "3", "unread"].includes(String(filterTags)) ? "active" : ""} aria-expanded={showFilter} onClick={() => setShowFilter(current => !current)}><FaFilter /> Filtros</button>
        {quickStatusFilters.map((state) => {
          const isPendingState = String(state.id) === "3";
          return <button type="button" key={state.id} disabled={filter === "pending" && !isPendingState} className={(filter === "pending" && isPendingState) || String(filterTags) === String(state.id) ? "active" : ""} onClick={() => { setFilterTags(String(state.id)); onFilterStatus(state.id); }}>{state.name}</button>;
        })}
        <button type="button" disabled={filter === "pending"} className={filterTags === "unread" ? "active" : ""} onClick={() => { setFilterTags("unread"); onFilterUnread(); }}>● No leídos</button>
      </div>

      {showFilter && (
        <section className="su-tag-filter" aria-label="Filtrar por etiqueta">
          <div className="su-tag-filter-heading">
            <span>Filtrar por etiqueta</span>
            {listTagsAll.length > 8 && (
              <button type="button" onClick={() => { setShowAllTags(current => !current); setTagSearchTerm(""); }}>
                {showAllTags ? "Ver menos" : `Ver todas (${listTagsAll.length})`}
              </button>
            )}
          </div>
          {(showAllTags || tagSearchTerm) && (
            <label className="su-tag-filter-search">
              <BsSearch aria-hidden="true" />
              <input value={tagSearchTerm} onChange={(event) => setTagSearchTerm(event.target.value)} placeholder="Buscar etiqueta" />
            </label>
          )}
          <div className="su-tag-filter-list">
            {visibleTags.map(tag => (
              <button type="button" key={tag._id} className={String(filterTags) === String(tag._id) ? "active" : ""} onClick={() => selectTagFilter(tag._id)}>
                <i style={{ backgroundColor: tag.color || "var(--su-accent-ink)" }} />
                {tag.title}
              </button>
            ))}
            {visibleTags.length === 0 && <span className="su-tag-filter-empty">No encontramos etiquetas</span>}
          </div>
          {filterTags !== "all" && !["1", "2", "3", "unread"].includes(String(filterTags)) && (
            <button type="button" className="su-tag-filter-clear" onClick={clearFilter}>Quitar filtro de etiqueta</button>
          )}
        </section>
      )}

      <header className="message d-flex legacy-chat-tools" style={{ flex: "0 0 auto", minHeight: "42px" }}>
        <div id="tittleFormProduct" className="d-flex w-100">
          <div className="col-6 pl-1 d-flex">
            <div className="pointer d-flex align-items-center" style={{padding: "0 10px"}}>
            {loadingListConv ? (
              <span className="d-flex">
                <FaSpinner
                  id="spinner-list-conv"
                  className="fa-spin"
                  style={{ fontSize: "23px" }}
                />
              </span>
            ) : (
              <BsSearch
                style={{ fontSize: "20px" }}
                data-tooltip-id={showTooltip ? "my-tooltip" : undefined} data-tooltip-content={showTooltip ? "Buscar conversación" : undefined}
                className="icon-search"
                onClick={() => {
                  setLoadingListConv(true);
                  setTimeout(() => {
                    setNewChat(true)
                    setSearchConversation(prevState => !prevState)
                    setLoadingListConv(false);
                  }, 1500);
                }}
              />
            )}
            </div>
            <div className="ml-0 d-flex align-items-center">
              <div className="dropdown mx-2 pointer status-chat d-flex align-items-center">
                <FaFilter style={{ fontSize: "20px", color: filterTags !== "all" ? "#4caf8f" : undefined }} data-tooltip-id={showTooltip ? "my-tooltip" : undefined} data-tooltip-content={showTooltip ? "Filtrar" : undefined} className="icon-filter"
                  onClick={() => {
                    if (showFilter) {
                      setShowFilter(false);
                    } else {
                      setShowFilter(true);
                    }
                  }}
                />
                {showFilter ? (
                  <div className="category-list position-absolute status-list" style={{ width: "200px", zIndex: "9", top: "0", left: "20px" }}>
                    <span
                      className="position-absolute close-transfer pointer"
                      style={{ right: "0.2rem", top: "0", fontSize:"1rem", fontWeight:"bold" }}
                      onClick={() => {
                        setShowFilter(false);
                      }}
                    >x</span>

                    <div className="mt-1" style={{borderBottom: "1px solid #ccc", margin: "0 10px"}}>
                      <div className="item-list">
                        <input
                          type="radio"
                          name="all"
                          id="all"
                          className="form-check-input mt-3"
                          style={{display: "none"}}
                          value="all"
                          onChange={(e) => {
                            onFilterTags(e.target.value);
                            setFilterTags("all")
                          }}
                        />
                        <label
                          htmlFor="all"
                          className="d-flex mb-0"
                          style={{
                            padding: "5px 2px 5px",
                            backgroundColor: filterTags === "all" ? "#aebac1" : "transparent"
                          }}
                        >
                          <div>
                            <label
                              htmlFor="all"
                              className="form-check-label pl-1 f-w-400"
                              style={filterTags === "all" ? {fontWeight:"700"} : {}}
                            >
                              Todos
                            </label>
                          </div>
                        </label>
                      </div>
                    </div>

                    <div className="mt-1" style={{borderBottom: "1px solid #ccc", margin: "0 10px"}}>
                      <h5 className="ml-1">Estados</h5>
                      {filterState.length > 0 && filterState.map((state, k) => (
                        <div key={k} className="item-list">
                          <input
                            type="radio"
                            name={state.id}
                            id={state.id}
                            className="form-check-input mt-3"
                            style={{display: "none"}}
                            value={state.id}
                            onChange={(e) => {
                              onFilterStatus(e.target.value);
                              setFilterTags(e.target.value)
                            }}
                          />
                          <label
                            htmlFor={state.id}
                            className="d-flex mb-0 rounded"
                            key={state.id}
                            style={{
                              padding: "5px 2px 5px",
                              backgroundColor: filterTags == state.id ? "#aebac1" : "transparent"
                            }}
                          >
                            <div>
                              <label
                                htmlFor={state.id}
                                className="form-check-label pl-1 f-w-400"
                                style={filterTags == state.id ? {fontWeight:"700"} : {} }
                              >
                                {state.name}
                              </label>
                            </div>
                          </label>
                        </div>
                      ))}
                    </div>

                    <div className="mt-1" style={{borderBottom: "1px solid #ccc", margin: "0 10px"}}>
                      <h5 className="ml-1">Mensajes</h5>
                      <div className="item-list">
                        <input
                          type="radio"
                          name="unread"
                          id="unread"
                          className="form-check-input mt-3"
                          style={{display: "none"}}
                          value="unread"
                          onChange={() => {
                            onFilterUnread();
                            setFilterTags("unread");
                          }}
                        />
                        <label
                          htmlFor="unread"
                          className="d-flex mb-0 rounded"
                          style={{
                            padding: "5px 2px 5px",
                            backgroundColor: filterTags === "unread" ? "#aebac1" : "transparent"
                          }}
                        >
                          <div>
                            <label
                              htmlFor="unread"
                              className="form-check-label pl-1 f-w-400"
                              style={filterTags === "unread" ? {fontWeight:"700"} : {}}
                            >
                              No leídos
                            </label>
                          </div>
                        </label>
                      </div>
                    </div>

                    <div className="mt-1" style={{borderBottom: "1px solid #ccc", margin: "0 10px"}}>
                      <h5 className="ml-1">Etiquetas</h5>
                      <div id='filt-tags' style={{maxHeight:"230px", overflow:"auto"}}>
                        {listTagsAll.length > 0 && listTagsAll
                        .sort((a, b) => a.title.localeCompare(b.title))
                        .map((tag, k) => (
                          <div key={k} className="item-list">
                            <input
                              type="radio"
                              name={tag._id}
                              id={tag._id}
                              className="form-check-input mt-3"
                              style={{display: "none"}}
                              value={tag._id}
                              onChange={(e) => {
                                onFilterTags(e.target.value);
                                setFilterTags(e.target.value)
                              }}
                            />
                            <label
                              htmlFor={tag._id}
                              className="d-flex mb-0"
                              key={tag._id}
                              style={{
                                padding: "5px 2px 5px",
                                backgroundColor: filterTags === tag._id ? "#aebac1" : "transparent"
                              }}
                            >
                              <div>
                                <label
                                  htmlFor={tag._id}
                                  className="form-check-label pl-1 f-w-400"
                                  style={filterTags === tag._id ? {fontWeight:"700"} : {} }
                                >
                                  {tag.title}
                                </label>
                              </div>
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>

                  </div>
                ) : null}
              </div>
            </div>
          </div>
          <div className="col-6 text-right pr-1 d-flex justify-content-end align-items-center">
            {filterTags !== "all" && (
              <span style={{
                display: "flex", alignItems: "center", gap: "3px",
                backgroundColor: "#e8f5e9", color: "#075e54",
                border: "1px solid #a5d6a7",
                borderRadius: "12px", padding: "2px 6px 2px 8px",
                fontSize: "11px", fontWeight: "600",
                maxWidth: "110px", marginRight: "auto", flexShrink: 1,
              }}>
                <span style={{overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>
                  {getFilterLabel()}
                </span>
                <IoClose
                  style={{cursor: "pointer", flexShrink: 0, fontSize: "13px"}}
                  onClick={clearFilter}
                />
              </span>
            )}
          {/*
          {activeCache ? (
              <FaDatabase
                style={{ fontSize: "24px", color: "#5cb85c", marginRight: "10px" }}
                data-tooltip-id="my-tooltip"
                data-tooltip-content="Desactivar cache"
                className="pointer"
                onClick={() => {
                  localStorage.setItem("STATE_CACHE", "false");
                  setActiveCache(false);
                }}
              />
            ) : (
              <FaBan
                style={{ fontSize: "24px", color: "#d9534f", marginRight: "10px" }}
                data-tooltip-id="my-tooltip"
                data-tooltip-content="Activar cache"
                className="pointer"
                onClick={() => {
                  localStorage.setItem("STATE_CACHE", "true");
                  setActiveCache(true);
                }}
              />
            )} 
            */}

            {activeNotification ? (
              <FaBell style={{ fontSize: "24px", color: "#5bc0de"}} data-tooltip-id={showTooltip ? "my-tooltip" : undefined} data-tooltip-content={showTooltip ? "Desactivar tono de notificaciones" : undefined} className="pointer"
              onClick={() => {
                const notificationsState = localStorage.getItem("STATE_NOT")
                notificationsState == "true" ? localStorage.setItem("STATE_NOT", "false") : localStorage.setItem("STATE_NOT", "true")
                setActiveNotification(false)
              }}
              />
            ) : (
              <FaBellSlash style={{ fontSize: "24px", color: "#455a64"}} data-tooltip-id={showTooltip ? "my-tooltip" : undefined} data-tooltip-content={showTooltip ? "Activar tono de notificaciones" : undefined} className="pointer"
              onClick={() => {
                const notificationsState = localStorage.getItem("STATE_NOT")
                notificationsState == "true" ? localStorage.setItem("STATE_NOT", "false") : localStorage.setItem("STATE_NOT", "true")
                setActiveNotification(true)
              }}
              />
            )}
            {loadingListContacts ? (
              <span className="d-flex" style={{ marginLeft: "7px" }}>
                <FaSpinner
                  className="fa-spin"
                  style={{ fontSize: "25px", color:"#5bc0de" }}
                />
              </span>
            ) : (
              <TbMessagePlus
                className="icon-lia-edit"
                style={{ fontSize: "28px", color: "#5bc0de", marginLeft: "5px", cursor: "pointer" }}
                aria-hidden="true"
                data-tooltip-id={showTooltip ? "my-tooltip" : undefined} data-tooltip-content={showTooltip ? "Nuevo chat" : undefined}
                onClick={handleNewChatClick}
              />
            )}
          </div>
        </div>
      </header>

      <header className="header-filter d-flex py-1 legacy-chat-filters" style={{ flex: "0 0 auto", minHeight: "42px" }}>
        <div className="d-flex justify-content-around align-items-center w-100">
          <a className={`py-1 btn-filter btn btn-link d-flex align-items-center ${filter === "mine" ? "active" : null}`} onClick={() => {
              filterByStatusAndTagsRef.current = '';
              getConversationsAsign()
            }}>
            <a className={conversationsAssignedCount > 0 ? 'pr-2' : ''}>
              Mios
            </a>
            {conversationsAssignedCount > 0 && (
              <div className="text-center d-flex">
                <div className="number-messages" style={{ fontSize: "12px" }}>
                  { conversationsAssignedCount }
                </div>
              </div>
            )}
          </a>
          <div className={`py-1 btn-filter btn btn-link d-flex align-items-center ${filter === "pending" ? "active" : null}`} onClick={() => {
              filterByStatusAndTagsRef.current = '';
              getConversationsPending()
            }}>
            <a className={conversationsPendingCount > 0 ? 'pr-2' : ''}>
              Pendientes
            </a>
            {conversationsPendingCount > 0 && (
              <div className="text-center d-flex">
                <div className="number-messages" style={{ fontSize: "12px" }}>
                  { conversationsPendingCount }
                </div>
              </div>
            )}
          </div>
          <a className={`py-1 btn-filter btn btn-link ${filter === "all" ? "active" : null}`} onClick={() => {
              filterByStatusAndTagsRef.current = '';
              getConversations();
            }}>
            Todos
          </a>
          <button
            className="bg-transparent border-0 d-flex"
            type="button"
            id="dropdownFilter"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <IoFilterCircleOutline data-tooltip-id={showTooltip ? "my-tooltip" : undefined} data-tooltip-content={showTooltip ? "Más filtros" : undefined} className="icon-filter-2 f-28 pointer" style={{color:"#9fb4b9"}}/>
          </button>
          <div id="content-dropdown-filter" className="dropdown-menu p-2" aria-labelledby="dropdownFilter">
            <a className={`d-block py-1 btn-filter btn btn-link ${filter === "onHold" ? "active" : null}`} onClick={() => getConversationsNoAsign()}>
              Sin asignar
            </a>
            {/*             
            {roleId === "6284fdd697029c6d9743ccb3" || roleId === "64886b1b250f9d31bf2ed68d" ? (
              <a className={`d-block py-1 btn-filter btn btn-link ${filter === "bots" ? "active" : null}`} onClick={() => getConversationsBots()}>
                Bots
              </a>
            ) : null} 
            */}
            <a className={`d-block py-1 btn-filter btn btn-link ${filter === "bots" ? "active" : null}`} onClick={() => getConversationsBots()}>
              Bots
            </a>
          </div>
        </div>
      </header>

      <div
        id="content-list-chats"
        className="mt-0"
        style={{ flex: "1 1 auto", minHeight: 0, overflowY: "auto", overflowX: "hidden" }}
        ref={conversationsListRef}
        onScroll={onScrollDownConversations}
      >
        <ul className="chat-list">
          {validationChats && (
            <h4 className="text-center">No existen registros</h4>
          )}

          {filteredConversations.length > 0 ? (filteredConversations.map((chat, k) => {
            const chatIdentifier = getWhatsappIdentifier(chat);
            const chatDisplayName = getWhatsappDisplayName(chat);
            let isStatus = true; 
            if (!chat.userData || Object.keys(chat.userData).length === 0) {
              isStatus = true
            } else if (chat.userData && chat.userData.status == false) {
              isStatus = false;
            }
            const initialWords = chatDisplayName.split(" ");
            let firstWord = initialWords[0];
            let secondWord = "";
            if(initialWords && initialWords.length > 1){
              firstWord = initialWords[0];
              secondWord = initialWords[1];
            }
            
            let icon = "";
            if (secondWord === undefined) {
              icon = firstWord[0];
            } else {
              icon = firstWord[0] + secondWord;
            }

            const phoneContext = localStorage.getItem("CHAT_SELECTED");
            if(phoneContext){
              if (isSameWhatsappIdentity(chat, phoneContext)) {
                localStorage.setItem("AGENT_ASIGN", chat.userAsign)
              }
            }

            var message = ""
            if (chat.messUlt) {
              message = chat.messUlt.length > 15 ? chat.messUlt.substr(0, 15) + "..." : chat.messUlt
            }
            const unreadCount = Number(chat.amount) || 0;

            return (
              <React.StrictMode key={k}>
                <li
                  key={k}
                  style={{
                    borderBottom: "1px solid rgb(0,0,0,0.05)",
                    justifyContent: "flex-start",
                  }}
                  className={isSameWhatsappIdentity(selectedChat, chatIdentifier) ? "li-chat chat-selected-active" : "li-chat" }
                  id={isSameWhatsappIdentity(selectedChat, chatIdentifier) ? "chat-selected-active" : ""}
                  onClick={() => {
                    console.log("calling onChatSelected from listUsersChats");
                    onChatSelected(chatIdentifier);
                    getTagContact(chat.phoneNumber || chatIdentifier);
                    setSelectedChat(chatIdentifier);
                    setClassChat(true);
                  }}
                >
                  <div className="d-flex">
                    <div className="col-2 pl-1" style={{ alignItems: "center", textAlign: "end" }}>
                      <IconList 
                        className="cont-avatar" 
                        style={{
                          border: isStatus ? `3px solid 
                          ${chat.statusConv == "1" ? "#00a884" : 
                            chat.statusConv == "2" ? "#f56f89" : "#a7ada7"
                          }` : ""
                        }}
                      >
                        {/* <Avvvatars value={icon} /> */}
                        {isStatus ? (
                          <Avvvatars value={icon} />
                        ) : (
                          <div className="" style={{width: "100%", height: "100%", background: "#ff5252"}}>
                            <BsPersonFillSlash style={{width: "100%", height: "100%", color:"#FFFFFF", padding: "7px"}}/>
                          </div>
                        )}
                      </IconList>
                      {
                        chat.permissions?.some(permission => permission.value === "feelings") && (
                          <p 
                            className="emoji-hover" 
                            style={{ position: "absolute", left: "-3px", top: "-10px", fontSize: "1.3rem", margin: "0" }}
                            data-tooltip-id={showTooltip ? "my-tooltip" : undefined} 
                            data-tooltip-content={showTooltip ? (chat.feeling && chat.feeling.length > 1 ? chat.feeling[1] : "") : undefined}
                          >
                            {chat.feeling && chat.feeling.length > 0 ? chat.feeling[0] : ""}
                          </p>
                        )
                      }
                    </div>

                    <div className="px-2 col-6">
                      <div>
                        <strong className="name-contact">
                          {chatDisplayName.length > 18
                            ? chatDisplayName.substr(0, 18) + "..."
                            : chatDisplayName}
                        </strong>
                      </div>
                      {/* Ultimo mensaje para mostrar */}
                      <div 
                        className={`span-color d-flex align-items-center ${chat.amount && 'active'}`} 
                        data-tooltip-id={showTooltip ? "conversation-preview-tooltip" : undefined}
                        data-tooltip-content={showTooltip ? (chat.messUlt ? (chat.messUlt.length > 500 ? chat.messUlt.substr(0, 500) + "..." : chat.messUlt) : "") : undefined} 
                        style={chat.amount ? {fontWeight:"600"} : {}}
                      >
                        
                        {/* Chulitos para identificar si el ultimo mensaje es del agente o cliente y saber si fue entregado y leido  */}
                        {chat.messagesList.length > 0 && chat.messagesList[chat.messagesList.length - 1]?.scheduled || chat.messagesList.length <= 0 && chat.messagesList[0]?.scheduled ? (
                          <IoIosAlarm className="mr-1 icon-alarm" style={{ fontSize: "20px", color: "#f79d27" }} />
                        ) : (chat.originMessage === "agent" && chat.statusMessage === "delivered") || (chat.originMessage === "agent" && chat.statusMessage === "sent") ? (
                          <BsCheckAll className="" style={{ fontSize: "26px" }} />
                        ) : (chat.originMessage === "agent" && chat.statusMessage === "pending") || (chat.originMessage === "agent" && chat.statusMessage === "") ? (
                          <BsCheck className="" style={{ fontSize: "26px" }} />
                        ) : chat.originMessage === "agent" && chat.statusMessage === "read" ? (
                          <BsCheckAll className="" style={{ color: "#5bc0de", fontSize: "26px" }} />
                        ) : null}
                        {
                          chat.typeMessUlt && chat.typeMessUlt === "sticker" ? (
                            <span className="d-flex align-items-center">
                              <PiStickerLight className="mr-1" style={{fontSize: "17px"}} />
                              {message}
                            </span>
                          ):
                          chat.typeMessUlt === "location" ? (
                            <span className="d-flex align-items-center">
                              <IoLocationOutline className="mr-1" style={{fontSize: "17px"}} />
                              {message}
                            </span>
                          ):
                          chat.typeMessUlt === "image" ? (
                            <span className="d-flex align-items-center">
                              <FaImage className="mr-1" style={{fontSize: "17px"}} />
                              {message ? message : "Imagen"}
                            </span>
                          ):
                          chat.typeMessUlt === "video" ? (
                            <span className="d-flex align-items-center">
                              <BsFillCameraVideoFill className="mr-1" style={{fontSize: "17px"}} />
                              {message ? message : "Video"}
                            </span>
                          ):
                          chat.typeMessUlt === "audio" ? (
                            <span className="d-flex align-items-center">
                              <HiMicrophone className="mr-1" style={{fontSize: "17px"}} />
                              {message ? message : "Audio"}
                            </span>
                          ):
                          chat.typeMessUlt === "document" ? (
                            <span className="d-flex align-items-center">
                              <BsFillFileEarmarkTextFill className="mr-1" style={{fontSize: "17px"}} />
                              {message ? message : "Documento"}
                            </span>
                          ):
                          chat.typeMessUlt === "template" ? (
                            <span className="d-flex align-items-center">
                              <HiTemplate className="mr-1" style={{fontSize: "17px"}} />
                              {message ? message : "Plantilla"}
                            </span>
                          ):
                          chat.typeMessUlt === "contacts" ? (
                            <span className="d-flex align-items-center">
                              <FaUser className="mr-1" style={{fontSize: "17px"}} />
                              {message ? message : "Contactos"}
                            </span>
                          ):
                          chat.typeMessUlt === "interactive" ? (
                            <span className="d-flex align-items-center">
                              <LuWorkflow className="mr-1" style={{fontSize: "17px"}} />
                              {message ? message : "Contactos"}
                            </span>
                          ):
                          chat.typeMessUlt === "products" ? (
                            <span className="d-flex align-items-center">
                              <TbCubeSend className="mr-1" style={{fontSize: "17px"}} />
                              {message ? message : "Productos"}
                            </span>
                          ):
                          chat.typeMessUlt === "order" ? (
                            <span className="d-flex align-items-center">
                              <HiShoppingCart className="mr-1" style={{fontSize: "17px"}} />
                              {message ? message : "Orden"}
                            </span>
                          ):
                          chat.typeMessUlt === "contextProduct" ? (
                            <span className="d-flex align-items-center">
                              <TiArrowBack className="mr-1" style={{fontSize: "17px"}} />
                              {message}
                            </span>
                          ):
                          chat.typeMessUlt === "contextText" ? (
                            <span className="d-flex align-items-center">
                              <TiArrowBack className="mr-1" style={{fontSize: "17px"}} />
                              {message}
                            </span>
                          ):
                          chat.typeMessUlt === "transfer" ? (
                            <span className="d-flex align-items-center">
                              <PiUserSwitchFill className="mr-1" style={{fontSize: "17px"}} />
                              {message}
                            </span>
                          ):
                          chat.typeMessUlt === "close_conv" ? (
                            <span className="d-flex align-items-center">
                              <TbMessage2X className="mr-1" style={{fontSize: "17px"}} />
                              {message}
                            </span>
                          ):
                          message
                        }
                      </div>
                      <div>
                        <p className="mb-0" style={chat.userAsign ? { color: "rgb(91, 192, 222)" } : { color: "rgb(251 0 0)" }}>
                          {chat.userAsign ? chat.userAsign : "Sin asignar"}
                        </p>
                      </div>
                    </div>

                    <div style={{ position: "relative", marginLeft: "auto", marginRight: "10px" }}>
                      <div className="span-color" style={{ fontSize: "12px" }}>
                        {/*dayjs(chat.lastDate).locale("es").format("DD-MMM hh:mm a")*/ getRelativeDate(chat.lastTimestamp)}
                      </div>

                      {unreadCount > 0 && (
                        <div className="text-center justify-content-end d-flex">
                          <div className="number-messages" style={{ fontSize: "12px" }}>
                            {unreadCount}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div style={{marginLeft: "1em"}}>
                      <ul className="d-flex">
                        {Array.isArray(chat.userData.tags) && chat.userData.tags.slice(0, 3).map((tag, t) => (
                          <li
                            key={t}
                            className="px-2 py-0 mr-2 border-0"
                            style={{
                              backgroundColor: tag.color,
                              fontSize: "0.75rem",
                              color: "#fff",
                              borderRadius: "7px"
                            }}
                          >
                            {tag.title && tag.title.length >= 9
                              ? tag.title.substr(0, 9) + "..."
                              : tag.title
                            }
                          </li>
                        ))}
                        {Array.isArray(chat.userData.tags) && chat.userData.tags.length > 3 && (
                          <li
                            className="px-0 py-0 mr-2 border-0"
                            style={{
                              fontSize: "0.8rem",
                            }}
                          >
                            +1
                          </li>
                        )}
                      </ul>
                  </div>
                </li>
              </React.StrictMode>
            )})
          ) : loadingChats ? (
            <h2 className="text-center mt-3">
              <FaSpinner
                className="fa-spin"
                style={{ fontSize: "25px" }}
              />
            </h2>
          ) : (
            <h2 className="text-center mt-3">No hay conversaciones</h2>
          )}
          {notMessages === 0 ? (
            <h2 className="text-center mt-3">No hay chats</h2>
          ) : null}
          {loadingMoreConversations ? (
            <h2 className="text-center mt-3">
              <FaSpinner
                className="fa-spin"
                style={{ fontSize: "25px" }}
              />
            </h2>
          ) : null}
        </ul>
      </div>

      {listUserChats && listUserChats.length > 0 ? (
          <h5 className="text-center m-0 d-flex align-items-center justify-content-center" style={{ flex: "0 0 auto", minHeight: "32px" }}>
            {textConversations}
          </h5>
      ) : null}
      <Tooltip
        id="conversation-preview-tooltip"
        className="su-conversation-preview-tooltip"
        place="top"
        positionStrategy="fixed"
        offset={8}
      />
    </>
  );
};

export default ListConversations;

const IconList = styled.div`
  margin-bottom: 0px;

  div {
    // box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.7);
    margin: 4px auto;
  }

  p {
    font-size: 18px;
    font-weight: 600;
  }
`;
